<template>
    <div class="bar" v-show="isShow">
        <ul class="tab-bar">
            <!-- <li v-for="(item,index) in navPicArray"
            :key="index"
            @click="changeImg(index,item)"
                >
                <img :src="item.img">
                <p>{{item.text}}</p>
            </li> -->
            <li @click="toIndex">
                <img src="https://images.jinku.com/newjk/org/images/bar/tabbar_1.jpg">
                <p>首页</p>
            </li>
            <li @click="toCeping">
                <img src="https://images.jinku.com/newjk/org/images/bar/tabbar_2.jpg">
                <p>评测</p>
            </li>
            <li @click="toBreviary(levelNum)">
                <img src="https://images.jinku.com/newjk/org/images/bar/tabbar_3.jpg">
                <p>路线</p>
            </li>
            <li @click="toCourse">
                <img src="https://images.jinku.com/newjk/org/images/bar/tabbar_4.jpg">
                <p>学习</p>
            </li>
            <li @click="toPersonal">
                <img src="https://images.jinku.com/newjk/org/images/bar/tabbar_5.jpg">
                <p>我的</p>
            </li>
        </ul>
        <router-view/>
    </div>
</template>

<script>
    import http from "../../lib/http.js";
    export default {
        name: 'bar',
        data() {
            return {
                isShow: true,
                      // navPicArray:[
                      //   {
                      //     text:"首页",
                      //     url:'/',
                      //     img:"https://images.jinku.com/newjk/org/images/bar/tabbar_1.jpg",
                      //   },
                      //   {
                      //     text:"评测",
                      //     url:'/ceping',
                      //     img:"https://images.jinku.com/newjk/org/images/bar/tabbar_2.jpg",
                      //   },
                      //   {
                      //     text:"路线",
                      //     url:'/breviary',
                      //     img:"https://images.jinku.com/newjk/org/images/bar/tabbar_3.jpg",
                      //   },
                      //   {
                      //     text:"学习",
                      //     url:'/Course',
                      //     img:"https://images.jinku.com/newjk/org/images/bar/tabbar_4.jpg",
                      //   },
                      //   {
                      //     text:"我的",
                      //     url:'/personal',
                      //     img:"https://images.jinku.com/newjk/org/images/bar/tabbar_5.jpg",
                      //     }
                      // ],
                      // num: 0,
                      // num == index ? item.active: item.img
                    levelNum:''
            }
        },
        methods: {
            // changeImg(index,item){
            //      this.num=index;
            //      this.$router.push(item.url).catch(err => err);
            // },
            toIndex(){
                this.$router.push('/').catch(function(err){

                });
            },
            toCeping(){
                this.$router.push('/ceping').catch(function(err){

                });
            },
            toBreviary(levelNum){
                // 用户信息
                this.$router.push({
                  name:"breviary",
                  path: "breviary",
        　　　　　　query:{
        　　　　　　　　levelNum:levelNum
        　　　　　　}
                }).catch(function(err){

                });

            },
            toCourse(){
                this.$router.push('/Course').catch(function(err){

                });
            },
            toPersonal(){
                this.$router.push('/personal').catch(function(err){

                });
            },
        },
        created() {
            if (navigator.userAgent.indexOf(';wealthmanagement-android') != -1) {
                this.isShow = false;
            } else if (navigator.userAgent.indexOf(';wealthmanagement-iOS') != -1) {
                this.isShow = false;
            }
            var that = this;
            http({
                method: 'POST',
                url: '/org/user/get'
            }).then((data) => {
                // if (!data) return;
                // data = data.data;
                // if (!data) return;
                that.levelNum = data.data.org_user_level;
            })
        }
    }
</script>

<style scoped>
    html,
    body {
        height: 100%;
    }
    .tab-bar {
        height: calc(96rpx + constant(safe-area-inset-bottom));
        height: calc(96rpx + env(safe-area-inset-bottom));
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }
    .router-link-active{
        color: red;
    }
    .tab-bar {
        width: 100%;
        height: .97rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        left: 0;
        bottom: 0;
        background: white;
        z-index: 100;
    }


    .tab-bar li {
        flex: 1;
        text-align: center;
    }

    .tab-bar li p {
        color: #c4c4c4;
    }

    .tab-bar li img {
        width: .42rem;
        height: .42rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/tab-bar/bar.vue